import { Controller } from 'stimulus';
import $ from 'jquery';
require("select2/dist/css/select2");
require("select2-bootstrap-theme/dist/select2-bootstrap");
export default class extends Controller {
  static targets = [
  "organizationWrapper",
  "organizationSelect"
]
 toggleRoles(event) {
  const selectedApp = event.target.value;
  const roleCheckboxes = this.element.querySelectorAll('.checkbox_role');
  const roleError = this.element.querySelector('#role-error');

  if (selectedApp === 'eyesol') {
    // Enable roles
    roleCheckboxes.forEach(checkbox => {
      checkbox.disabled = false;
      const label = checkbox.closest('label');
      if (label) {
        label.style.opacity = '1';
        label.style.cursor = 'pointer';
      }
    });

    // Hide organization dropdown
    this.organizationWrapperTarget.classList.add('hidden');
    this.organizationSelectTarget.innerHTML = '';

    if (roleError) roleError.classList.add('hidden');

  } else {
    // Disable roles
    roleCheckboxes.forEach(checkbox => {
      checkbox.checked = false;
      checkbox.disabled = true;
      const label = checkbox.closest('label');
      if (label) {
        label.style.opacity = '0.5';
        label.style.cursor = 'not-allowed';
      }
    });

    if (roleError) roleError.classList.add('hidden');

    // Show organization dropdown
    this.organizationWrapperTarget.classList.remove('hidden');
     this.initSelect2Once();
    // Load organizations for selected app
    this.loadOrganizations(selectedApp);
  }
}

loadOrganizations(primaryApp) {
  fetch(`/primary_apps/${primaryApp}/organizations`)
    .then(response => response.json())
    .then(data => {
      const selectedIds = JSON.parse(this.organizationSelectTarget.dataset.selectedOrganizationIds || '[]').map(String);
      this.organizationSelectTarget.innerHTML = '';

      data.forEach(org => {
        const option = document.createElement('option');
        option.value = org.id;
        option.textContent = org.name;
        if (selectedIds.includes(String(org.id))) {
          option.selected = true;
        }
        this.organizationSelectTarget.appendChild(option);
      });

      if ($(this.organizationSelectTarget).hasClass('select2-hidden-accessible')) {
        $(this.organizationSelectTarget).trigger('change');
      }
    });
}

initSelect2Once() {
  if (!this.organizationSelectTarget.classList.contains('select2-initialized')) {
    $(this.organizationSelectTarget).select2({
      width: '100%'
    });
    this.organizationSelectTarget.classList.add('select2-initialized');
  }
}

  connect() {
    // Check initial state on page load
    const primaryAppSelect = this.element.querySelector('select[name*="[primary_app]"]');
    if (primaryAppSelect) {
      const selectedApp = primaryAppSelect.value;
      if (selectedApp && selectedApp !== 'eyesol') {
        this.toggleRoles({ target: primaryAppSelect });
      }
    }
  }
}
